// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

export { default } from './Text';



// WEBPACK FOOTER //
// ./components/Text/index.js